module.exports = __webpack_public_path__ + "statics/img/Nullcar.38a5fd9b.png";